import { useState, useEffect } from "react";

/**
 * Custom hook to detect desktop screen width (1024px+)
 * Use this for split-view layouts that need minimum width
 * @returns {boolean} true if screen width is >= 1024px
 */
function useDesktop() {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

  useEffect(() => {
    const mql = window.matchMedia("(min-width: 1024px)");
    const onChange = (e) => setIsDesktop(e.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isDesktop;
}

export default useDesktop;
